import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { ApiMessage, ApiMessageParams } from './apiMessage.types';

export const getApiMessageList = (client: AxiosInstance) => async (params: ApiMessageParams) => {
  return (await client.get<PaginatedApiResponse<ApiMessage[]>>(API_ROUTES.GET_API_MESSAGE_LIST, { params })).data;
};

export const getApiMessageDetail = (client: AxiosInstance) => async (apiMessageId: string) => {
  return (
    await client.get<ApiResponse<ApiMessage>>(API_ROUTES.GET_API_MESSAGE_DETAIL, {
      params: { apiMessageId },
    })
  ).data;
};

export const apiMessageQueries = {
  all: () => ['api-message'],
  list: (params: ApiMessageParams) =>
    queryFactoryOptions<PaginatedApiResponse<ApiMessage[]>>({
      queryKey: [...apiMessageQueries.all(), 'list', params],
      queryFn: (client) => () => getApiMessageList(client)(params),
    }),
  detail: (apiMessageId: string) =>
    queryFactoryOptions<ApiResponse<ApiMessage>>({
      queryKey: [...apiMessageQueries.all(), 'detail', apiMessageId],
      queryFn: (client) => () => getApiMessageDetail(client)(apiMessageId),
    }),
};
